import styled from 'styled-components';
import { themeSpacing } from '@amsterdam/asc-ui';

export const IndividualFieldsFormStyle = styled.div`
	padding-bottom: ${themeSpacing(8)};
`;
